import { graphql } from "../gql";

graphql(`
  fragment ClaimRoleAssignmentsFields on ClaimRoleAssignments {
    claimId
    updatedAt
    assignments {
      userId
      roleId
      user {
        id
        firstName
        lastName
      }
      role {
        id
        name
      }
    }
  }
`);

export const getClaimRoleAssignmentsDoc = graphql(`
  query GetClaimRoleAssignments($claimId: UUID!) {
    claimRoleAssignments(claimId: $claimId) {
      ...ClaimRoleAssignmentsFields
    }
  }
`);

export const saveClaimRoleAssignmentsDoc = graphql(`
  mutation SaveClaimRoleAssignments($input: SaveClaimRoleAssignmentsInput!) {
    saveClaimRoleAssignments(input: $input) {
      ... on SaveClaimRoleAssignmentsPayload {
        claimRoleAssignments {
          ...ClaimRoleAssignmentsFields
        }
      }
      ... on SaveClaimRoleAssignmentsConflict {
        message
        current {
          ...ClaimRoleAssignmentsFields
        }
      }
    }
  }
`);
